// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFeeDto
 */
export interface IFeeDto {
    /**
     * 
     * @type {number}
     * @memberof IFeeDto
     */
    fee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeDto
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IFeeDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IFeeDto
     */
    account_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IFeeDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeDto
     */
    posting_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IFeeDto
     */
    transaction_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IFeeDto
     */
    fee_type?: IFeeDtoFeeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IFeeDto
     */
    payment_fee_type?: IFeeDtoPaymentFeeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IFeeDto
     */
    policy_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeDto
     */
    reimbursement_invoice_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IFeeDtoFeeTypeEnum {
    PAYMENT_FEE = 'PAYMENT_FEE',
    ACCOUNT_MAINTENANCE_FEE = 'ACCOUNT_MAINTENANCE_FEE',
    PAPER_STATEMENT_FEE = 'PAPER_STATEMENT_FEE'
}
/**
* @export
* @enum {string}
*/
export enum IFeeDtoPaymentFeeTypeEnum {
    ACH = 'ACH',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}


/**
 * Check if a given object implements the IFeeDto interface.
 */
export function instanceOfIFeeDto(value: object): value is IFeeDto {
    return true;
}

export function IFeeDtoFromJSON(json: any): IFeeDto {
    return IFeeDtoFromJSONTyped(json, false);
}

export function IFeeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFeeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fee_id': json['fee_id'] == null ? undefined : json['fee_id'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'account_name': json['account_name'] == null ? undefined : json['account_name'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'posting_id': json['posting_id'] == null ? undefined : json['posting_id'],
        'transaction_at': json['transaction_at'] == null ? undefined : (new Date(json['transaction_at'])),
        'fee_type': json['fee_type'] == null ? undefined : json['fee_type'],
        'payment_fee_type': json['payment_fee_type'] == null ? undefined : json['payment_fee_type'],
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'reimbursement_invoice_id': json['reimbursement_invoice_id'] == null ? undefined : json['reimbursement_invoice_id'],
    };
}

export function IFeeDtoToJSON(json: any): IFeeDto {
    return IFeeDtoToJSONTyped(json, false);
}

export function IFeeDtoToJSONTyped(value?: IFeeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fee_id': value['fee_id'],
        'claim_id': value['claim_id'],
        'amount': value['amount'],
        'plan_name': value['plan_name'],
        'account_name': value['account_name'],
        'account_id': value['account_id'],
        'posting_id': value['posting_id'],
        'transaction_at': value['transaction_at'] == null ? undefined : ((value['transaction_at']).toISOString()),
        'fee_type': value['fee_type'],
        'payment_fee_type': value['payment_fee_type'],
        'policy_id': value['policy_id'],
        'reimbursement_invoice_id': value['reimbursement_invoice_id'],
    };
}

